export function normalizeMarkdownBullets(markdown: string): string {
  return markdown
    .replace(/^(\s*)•\s+/gm, '$1- ')
    .replace(/^(\s*)‣\s+/gm, '$1- ');
}
